import axiosInstance from './axiosConfig';
import axios from 'axios';
import { API_BASE_URL } from './axiosConfig';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Kullanıcının çocuklarını getir
export const getMyChildren = async () => {
  try {
    const response = await axiosInstance.get('/children/my');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Çocuk bilgilerini ID'ye göre getir
export const getChildById = async (childId) => {
  try {
    const response = await axiosInstance.get(`/children/my/${childId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Yeni çocuk profili oluştur
export const createChild = async (childData) => {
  try {
    const response = await axiosInstance.post('/children', childData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Çocuk profilini güncelle
export const updateChild = async (childId, childData) => {
  try {
    const response = await axiosInstance.put(`/children/${childId}`, childData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Çocuk profilini sil
export const deleteChild = async (childId) => {
  // ID'nin sayı olduğundan emin olalım
  const numericId = typeof childId === 'string' ? parseInt(childId, 10) : childId;
  
  //console.log(`deleteChild API çağrısı: childId=${childId}, dönüştürülen ID=${numericId}, tipi=${typeof numericId}`);
  
  try {
    const url = `/children/${numericId}`;
    //console.log(`API tam endpoint: ${API_BASE_URL}${url}`);
    
    // Eskiden: const response = await axiosInstance.delete(url);
    // Direkt olarak axios.delete kullanarak sorunu giderelim
    //console.log('Direkt axios.delete kullanılıyor...');
    const response = await axios.delete(`${API_BASE_URL}/children/${numericId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await AsyncStorage.getItem('token')}`
      }
    });
    
    //console.log('Silme API yanıtı:', response.data);
    return response.data;
  } catch (error) {
    console.error('Silme API hatası:', error);
    console.error('Hata yanıtı:', error.response?.data);
    
    // Daha detaylı hata bilgisi
    if (error.request) {
      // İstek gönderildi ancak yanıt alınamadı
      console.error('İstek detayları:', error.request._response || error.request);
    }
    
    throw error.response?.data || error.message;
  }
};
